// extracted by mini-css-extract-plugin
export default {"title":"SingleCertificateTypeContainer_title__xk8mo"};